import { createAction, props } from '@ngrx/store';

import { ActiveVisualizationModulesState } from '@core/models/data-visualization/data-visualization.model';

const ACTION_PREFIX = '[Popup Data Visualization]';

export const openPopup = createAction(`${ACTION_PREFIX} Open Popup`);
export const closePopup = createAction(`${ACTION_PREFIX} Close Popup`);
export const markAsPopup = createAction(`${ACTION_PREFIX} Mark as Popup`);
export const registerDataVisualizationPopup = createAction(
  `${ACTION_PREFIX} Register Popup`,
  props<{ popupId: string }>()
);
export const unregisterDataVisualizationPopup = createAction(
  `${ACTION_PREFIX} Unregister Popup`,
  props<{ popupId: string }>()
);

export const setActiveVisualizationModules = createAction(
  `${ACTION_PREFIX} Set Active Visualization Modules`,
  props<ActiveVisualizationModulesState>()
);

export const setFilteringState = createAction(
  `${ACTION_PREFIX} Set Filtering State`,
  props<{ isFilteringEnabled: boolean }>()
);
